import { AppRoutingRouteNames } from '@pxl/route-names';
import { isKnownUserGuard } from './is-known-user.guard';

export const knownUserToDashboardGuard = isKnownUserGuard(false, [AppRoutingRouteNames.Dashboard]);
